/**
 * useHomeDestination -- where the "go to start" action of the 404 / route-error page leads,
 * by role (FEAT-047 design.md 1.2). Anonymous or unresolved sessions go to the login.
 * Under impersonation the auth store already holds the impersonated user, so its role wins.
 */

import { useAuthStore } from '@/stores/useAuthStore';

export type HomeDestinationKey = 'chat' | 'admin' | 'login';

export interface HomeDestination {
  key: HomeDestinationKey;
  path: string;
  /** True while the session is still being confirmed (role unknown). */
  isResolving: boolean;
}

export function useHomeDestination(): HomeDestination {
  const isHydrated = useAuthStore((s) => s.isHydrated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const role = useAuthStore((s) => s.user?.role);

  const isResolving = isLoading || !isHydrated;

  if (isResolving || !isAuthenticated || !role) {
    return { key: 'login', path: '/login', isResolving };
  }
  if (role === 'admin' || role === 'maintainer') {
    return { key: 'admin', path: '/admin', isResolving: false };
  }
  return { key: 'chat', path: '/chat', isResolving: false };
}
